import { render, staticRenderFns } from "./CommunityView.vue?vue&type=template&id=2172984a&scoped=true"
import script from "./CommunityView.vue?vue&type=script&lang=js"
export * from "./CommunityView.vue?vue&type=script&lang=js"
import style0 from "./CommunityView.vue?vue&type=style&index=0&id=2172984a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2172984a",
  null
  
)

export default component.exports